module.exports = __webpack_public_path__ + "img/16581303_L.5fdc0438.png";